var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdIdeaGradientOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8110_4704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.81201C11.6117 2.81201 11.2969 3.12682 11.2969 3.51514C11.2969 3.90345 11.6117 4.21826 12 4.21826C14.3266 4.21826 16.2195 6.11079 16.2195 8.43701C16.2195 8.82532 16.5343 9.14014 16.9226 9.14014C17.3109 9.14014 17.6257 8.82532 17.6257 8.43701C17.6257 5.33539 15.102 2.81201 12 2.81201Z",
    fill: "url(#paint0_linear_8110_4704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1871 0.18884C7.01041 0.852637 4.43463 3.40376 3.75686 6.60022C3.18456 9.29937 3.8898 12.0092 5.69172 14.0349C6.57255 15.0251 7.07767 16.3321 7.07767 17.6245V19.0307C7.07767 19.9663 7.69019 20.7612 8.53516 21.0365C8.81303 22.6783 10.238 23.9994 11.9995 23.9994C13.7606 23.9994 15.186 22.6787 15.4639 21.0365C16.3089 20.7612 16.9214 19.9663 16.9214 19.0307V17.6244C16.9214 16.3295 17.4282 15.0382 18.3484 13.9884C19.6953 12.4518 20.437 10.4802 20.437 8.43697C20.437 3.11361 15.5644 -0.934566 10.1871 0.18884ZM11.9995 22.5932C11.0957 22.5932 10.3032 21.9713 10.0106 21.1354H13.9885C13.6959 21.9713 12.9034 22.5932 11.9995 22.5932ZM15.5152 19.0307C15.5152 19.4184 15.1998 19.7338 14.812 19.7338H9.18705C8.79935 19.7338 8.48392 19.4184 8.48392 19.0307V18.3276H15.5152V19.0307ZM17.2909 13.0615C16.3103 14.1803 15.7069 15.5293 15.5538 16.9213H8.44539C8.29249 15.5286 7.69071 14.1663 6.74252 13.1003C5.24074 11.412 4.65391 9.14914 5.13255 6.89192C5.69125 4.25689 7.83813 2.11634 10.4748 1.56542C14.9759 0.624778 19.0308 4.00503 19.0308 8.43697C19.0308 10.1391 18.4129 11.7815 17.2909 13.0615Z",
    fill: "url(#paint1_linear_8110_4704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10938 8.43701H0.703125C0.314812 8.43701 0 8.75182 0 9.14014C0 9.52845 0.314812 9.84326 0.703125 9.84326H2.10938C2.49769 9.84326 2.8125 9.52845 2.8125 9.14014C2.8125 8.75182 2.49769 8.43701 2.10938 8.43701Z",
    fill: "url(#paint2_linear_8110_4704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39974 4.9215L1.40538 3.92714C1.13084 3.65254 0.685617 3.65254 0.411023 3.92714C0.13643 4.20173 0.13643 4.6469 0.411023 4.9215L1.40538 5.91586C1.67993 6.19045 2.12515 6.1905 2.39974 5.91586C2.67434 5.64126 2.67434 5.19609 2.39974 4.9215Z",
    fill: "url(#paint3_linear_8110_4704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39974 12.3646C2.12515 12.09 1.67993 12.09 1.40538 12.3646L0.411023 13.359C0.13643 13.6336 0.13643 14.0788 0.411023 14.3534C0.68557 14.6279 1.13079 14.628 1.40538 14.3534L2.39974 13.359C2.67434 13.0844 2.67434 12.6392 2.39974 12.3646Z",
    fill: "url(#paint4_linear_8110_4704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2969 8.43701H21.8906C21.5023 8.43701 21.1875 8.75182 21.1875 9.14014C21.1875 9.52845 21.5023 9.84326 21.8906 9.84326H23.2969C23.6852 9.84326 24 9.52845 24 9.14014C24 8.75182 23.6852 8.43701 23.2969 8.43701Z",
    fill: "url(#paint5_linear_8110_4704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5872 3.92714C23.3127 3.65254 22.8675 3.65254 22.5929 3.92714L21.5985 4.9215C21.3239 5.19609 21.3239 5.64126 21.5985 5.91586C21.8731 6.1904 22.3183 6.19045 22.5929 5.91586L23.5872 4.9215C23.8618 4.6469 23.8618 4.20173 23.5872 3.92714Z",
    fill: "url(#paint6_linear_8110_4704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5872 13.359L22.5929 12.3646C22.3183 12.09 21.8731 12.09 21.5985 12.3646C21.3239 12.6392 21.3239 13.0844 21.5985 13.359L22.5929 14.3534C22.8674 14.6279 23.3126 14.6279 23.5872 14.3534C23.8618 14.0788 23.8618 13.6336 23.5872 13.359Z",
    fill: "url(#paint7_linear_8110_4704)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8110_4704",
    x1: 17.6461,
    y1: 11.0031,
    x2: 9.5469,
    y2: 8.17539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8110_4704",
    x1: 20.4913,
    y1: 31.0645,
    x2: -2.35899,
    y2: 25.4556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8110_4704",
    x1: 2.82154,
    y1: 10.2573,
    x2: 0.106909,
    y2: 8.36191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8110_4704",
    x1: 2.61341,
    y1: 6.82855,
    x2: -0.45879,
    y2: 5.75606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8110_4704",
    x1: 2.61341,
    y1: 15.266,
    x2: -0.45879,
    y2: 14.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8110_4704",
    x1: 24.009,
    y1: 10.2573,
    x2: 21.2944,
    y2: 8.36191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8110_4704",
    x1: 23.8009,
    y1: 6.8285,
    x2: 20.7287,
    y2: 5.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8110_4704",
    x1: 23.8009,
    y1: 15.266,
    x2: 20.7287,
    y2: 14.1935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8110_4704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdIdeaGradientOutline);
export default __webpack_public_path__ + "static/media/ad-idea-gradient-outline.cbddc31bc42d689b1ca637df52f572fd.svg";
export { ForwardRef as ReactComponent };